module.exports = __webpack_public_path__ + "static/media/teacherReferal.84357044.png";